import styled from "@emotion/styled";

const HeaderBackdrop = styled.header`
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export default HeaderBackdrop;
